import React, { useState, useEffect } from "react";
import { GoStack } from "react-icons/go";
import { MdFamilyRestroom, MdBusinessCenter } from "react-icons/md";
import { FaLeaf } from "react-icons/fa";
import { AiOutlinePercentage } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import Package from "./Package";
import { getPackageData } from "../data";

const Packages = () => {
  const { t } = useTranslation();
  const [selectedPackage, setSelectedPackage] = useState(1);
  const [packageData, setPackageData] = useState([]);

  useEffect(() => {
    setPackageData(getPackageData(t));
  }, [t]);

  const tiles = [
    {
      id: 1,
      pic: GoStack,
      title: t("Wszystkie"),
    },
    {
      id: 2,
      pic: MdFamilyRestroom,
      title: t("Rodzina"),
    },
    {
      id: 3,
      pic: MdBusinessCenter,
      title: t("Biznes"),
    },
    {
      id: 4,
      pic: FaLeaf,
      title: t("Sezonowe"),
    },
    {
      id: 5,
      pic: AiOutlinePercentage,
      title: t("Promocje"),
    },
  ];

  const filteredPakiety = selectedPackage === 1 ? packageData : packageData.filter(pakiet => pakiet.type === selectedPackage);

  return (
    <section className="py-24 mx-5">
      <div className="text-center">
        <div className="font-tertiary uppercase text-[15px] tracking-[6px] ">
          {t("DostosowaneDla")}
        </div>
        <h2 className="font-primary text-[45px] mb-4">{t("Pakiety")}</h2>
      </div>
      <div className="flex justify-center flex-wrap ">
        {tiles.map((item) => {
          const IconComponent = item.pic;
          return (
            <div key={item.id} className={`flex flex-col items-center cursor-pointer m-4 rounded-full lg:w-16 lg:h-16 w-14 h-14 ${selectedPackage === item.id ? 'btn-primary text-white' : 'bg-gray-300'}  p-4`} onClick={() => setSelectedPackage(item.id)}>
              <IconComponent size={24} /> 
              <span className="text-[8px]">{item.title}</span>
            </div>
          );
        })}
      </div>
      <div className="flex lg:flex-row flex-col justify-around lg:mx-[10%]">
        {filteredPakiety.map((pakiet) => (
          <Package room={pakiet} key={pakiet.id} />
        ))}
      </div>
    </section>
  );
};

export default Packages;
